// Canonical US Letter document coordinates at 96 CSS pixels per inch.
export const INVOICE_DOCUMENT_WIDTH = 816;
export const INVOICE_DOCUMENT_HEIGHT = 1056;
export const INVOICE_PDF_WIDTH = 612;
export const INVOICE_PDF_HEIGHT = 792;
export const INVOICE_LETTER_SCREEN_SCALE = 1;
export const INVOICE_DOCUMENT_MAX_RENDERED_WIDTH = 816;
export const INVOICE_DOCUMENT_WORKSPACE_RESERVE = 0;
// Estimates reuse the accepted document coordinates.
export const ESTIMATE_DOCUMENT_WIDTH = INVOICE_DOCUMENT_WIDTH;
export const ESTIMATE_DOCUMENT_HEIGHT = INVOICE_DOCUMENT_HEIGHT;
export const ESTIMATE_DOCUMENT_MAX_RENDERED_WIDTH = INVOICE_DOCUMENT_MAX_RENDERED_WIDTH;
export const ESTIMATE_DOCUMENT_WORKSPACE_RESERVE = INVOICE_DOCUMENT_WORKSPACE_RESERVE;
export const ESTIMATE_LETTER_SCREEN_SCALE = INVOICE_LETTER_SCREEN_SCALE;
